export default __webpack_public_path__ + "static/media/CustoImage (1).c2a65b67.png";